import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  ClearTimePayload,
  ClearTimeResponse,
  ClearTimeSingleResponse
} from 'Interfaces/ReferenceInterfaces/ClearTimeInterface';

export const clearTimeServices = {
  getAllClearTimes: (page = 1, pageSize = 10000): Promise<ClearTimeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<ClearTimeResponse>(
          `pps/clear-times?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getClearTimeById: (id: number): Promise<ClearTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<ClearTimeSingleResponse>(`pps/clear-times/${id}/`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createClearTime: (clearTimeData: ClearTimePayload): Promise<ClearTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<ClearTimeSingleResponse>(
          'pps/clear-times/',
          clearTimeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateClearTime: (
    id: number,
    clearTimeData: ClearTimePayload
  ): Promise<ClearTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<ClearTimeSingleResponse>(
          `pps/clear-times/${id}/`,
          clearTimeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteClearTime: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/clear-times/${id}/`);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  }
};
